import { useEffect, useState } from "react";

export const useSlowQueryDetection = (isQueryRunning: boolean, thresholdMs: number = 75000): boolean => {
  const [queryStartTime, setQueryStartTime] = useState<number | null>(null);
  const [showSlowQueryMessage, setShowSlowQueryMessage] = useState(false);

  useEffect(() => {
    if (isQueryRunning && queryStartTime === null) {
      setQueryStartTime(Date.now());
      setShowSlowQueryMessage(false);
    } else if (!isQueryRunning) {
      setQueryStartTime(null);
      setShowSlowQueryMessage(false);
    }
  }, [isQueryRunning, queryStartTime]);

  useEffect(() => {
    if (!queryStartTime || !isQueryRunning) return;

    const timer = setTimeout(() => {
      if (isQueryRunning) {
        setShowSlowQueryMessage(true);
      }
    }, thresholdMs);

    return () => {
      clearTimeout(timer);
    };
  }, [queryStartTime, isQueryRunning, thresholdMs]);

  return showSlowQueryMessage;
};
